"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetPromoDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const validation_1 = require("./validation");
const types_2 = require("../../../../../../types");
const tokenTypeByService = {
    [types_2.ServiceType.ADMIN]: [types_1.TokenType.ERC721, types_1.TokenType.ERC998],
    [types_2.ServiceType.OFFICE]: [types_1.TokenType.ERC721],
};
const AssetPromoDialogForm = (props) => {
    const { selectedItem, open, mode, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, item, price, startTimestamp, endTimestamp, merchantId } = selectedItem;
    const fixedValues = {
        id,
        item,
        price,
        startTimestamp,
        endTimestamp,
        merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "AssetPromoEditForm", filter: ({ item, price, startTimestamp, endTimestamp, merchantId }) => ({
            item: (0, exchange_1.cleanUpAsset)(item),
            price: (0, exchange_1.cleanUpAsset)(price),
            merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
            startTimestamp,
            endTimestamp,
        }), ...rest, children: [service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "merchantId", controller: "merchants", disableClear: true }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "item" }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "price", tokenType: { disabledOptions: tokenTypeByService[service] } }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: "startTimestamp" }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: "endTimestamp" })] }));
};
exports.AssetPromoDialogForm = AssetPromoDialogForm;
//# sourceMappingURL=index.js.map